import React, { Component } from "react";
import PropTypes from "prop-types";

import { getParamPairs } from "../../../utils/utils";
import SearchInputBox from "./SearchInputBox";
import SearchResults from "./SearchResults";
import CollectionResults from "./CollectionResults";
import { Dimmer, Header, Icon, Segment } from "semantic-ui-react";
import MiscSearchResults from "./MiscSearchResults";
import TopMenuWithBackButton from "./TopMenuWithBackButton";
import TrackListPlaceholder from "../VotifyQueue/TrackListPlaceholder";

const getItemFromMiscSearchResults = (collection, results) => {
  try {
    const [, type, id] = collection.split(":");
    return results[`${type}s`].items.find(({ id: _id }) => _id === id);
  } catch (error) {
    return null;
  }
};

class VotifySearchComponent extends Component {
  constructor(props) {
    super(props);

    console.log("VotifySearchComponent location");
    console.log(this.props.location);

    this.sendVote = this.sendVote.bind(this);
    this.sendGetTrackRequest = this.props.sendGetTrackRequest.bind(this);
  }

  sendVote(trackId) {
    this.props.sendVote(trackId);
  }

  clickVote(trackUri) {
    const trackIdRegEx = new RegExp(/^spotify:track:[a-zA-Z0-9]{22}$/);
    if (trackIdRegEx.test(trackUri)) {
      this.sendVote(trackUri);
    } else {
      console.warn(`Bad track id: ${trackUri}`);
    }
  }

  render() {
    const { collection } = getParamPairs(this.props.location.search);
    if (collection) {
      const item = getItemFromMiscSearchResults(
        collection,
        this.props.miscSearchResults,
      );
      if (item) {
        return (
          <div>
            <TopMenuWithBackButton header={item.name} />
            <CollectionResults />
          </div>
        );
      }
    }
    return (
      <div>
        <SearchInputBox
          editSearchString={this.props.editSearchString}
          inputString={this.props.searchString}
          isLoading={this.props.isLoading}
          submitSearch={this.props.sendSearchRequest}
          sendGetTrackRequest={this.sendGetTrackRequest}
        />
        {(this.props.searchString && this.props.searchString.length > 0 && (
          <>
            <Dimmer.Dimmable dimmed={this.props.isLoading} blurring>
              {(!this.props.isLoading &&
                this.props.searchResults.length === 0 && (
                  <Header
                    textAlign="center"
                    inverted
                  >{`No results for ${this.props.searchString}`}</Header>
                )) ||
                (this.props.searchResults.length > 0 && (
                  <SearchResults
                    clickVote={this.props.sendVote}
                    results={this.props.searchResults}
                    isLoading={this.props.isLoading}
                    participantVotes={this.props.participantVotes}
                    isMore={this.props.isMore}
                    getNextPage={this.props.getNextPage}
                    votes={this.props.votes}
                  />
                )) || <TrackListPlaceholder length={16} />}
              <MiscSearchResults
                isLoading={this.props.isLoading}
                results={this.props.miscSearchResults}
              />
            </Dimmer.Dimmable>
          </>
        )) || (
          <Segment
            textAlign={"center"}
            basic
            style={{
              top: "12rem",
              left: 0,
              right: 0,
              position: "absolute",
              margin: "auto",
            }}
          >
            <Icon size={"massive"} name={"search"} color={"grey"} />
            <Header as={"h1"} content={"search"} color={"grey"} />
          </Segment>
        )}
      </div>
    );
  }
}

VotifySearchComponent.propTypes = {
  sendVote: PropTypes.func.isRequired,
  sendSearchRequest: PropTypes.func.isRequired,
  sendGetTrackRequest: PropTypes.func.isRequired,
  editSearchString: PropTypes.func.isRequired,
  getNextPage: PropTypes.func.isRequired,
  searchResults: PropTypes.array.isRequired,
  miscSearchResults: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  isMore: PropTypes.bool,
  queue: PropTypes.array,
  votes: PropTypes.object,
  partyId: PropTypes.string,
};

export default VotifySearchComponent;
